import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';
import { Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderBar from './components/ui/HeaderBar';
import MyRoutes from './components/routes/MyRoutes';
import axios from 'axios';

let theme = createTheme({
    palette: {
        mode: 'light',
        background: { default: '#f9f9fb', paper: '#ffffff' },
        primary: { main: '#237762', dark: '#0a3d31', contrastText: '#ffffff' },
        text: { primary: '#2a2e35', secondary: '#6c7d75' }
    },
    typography: {
        fontFamily: ['"Public Sans"', 'sans-serif'].join(','),
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        button: { textTransform: 'none', fontWeight: 500 }
    },
    shape: { borderRadius: 12 }
});

theme = responsiveFontSizes(theme);

const App = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [authToken, setAuthToken] = useState(null); // eslint-disable-line no-unused-vars

    useEffect(() => {
      const token = localStorage.getItem('token');
      const publicPaths = ['/login', '/admin-login', '/reset-password', '/forgot-password'];
      const isPublic = publicPaths.some(path =>
        location.pathname.startsWith(path)
      );

      // If there’s no token and we’re NOT on a public path, go to /login
      if (!token && !isPublic) {
        navigate('/login', { replace: true });
      }

      // Keep the authToken state up‑to‑date (null if missing)
      setAuthToken(token);

      setLoading(false);
    }, [location.pathname, navigate]);


    const handleAnswerCreate = async (questionId, userId, answer, role) => {
        const userApplication = localStorage.getItem('userApplication');
        try {
            await axios.post(`/api/answers/${userApplication}/create`, {
                answerId: questionId + userId,
                questionId,
                userId,
                answer,
                role,
                date: Date.now().toString()
            });
        } catch (error) {
            console.error(`Failed to save answer: ${error}`);
        }
    };

    // List of routes where we want to hide the HeaderBar
    const hideHeaderRoutes = ['/login', '/reset-password', '/register', '/registeredUsers', '/forgot-password', '/assessment-info'];
    const shouldHideHeader = hideHeaderRoutes.some(path => location.pathname.startsWith(path));

    if (loading) return <div>Loading...</div>;

    return (
        <ThemeProvider theme={theme}>
            {!shouldHideHeader && ( // Conditionally render HeaderBar
                <Grid container justifyContent="center">
                    <Grid item xs={12}>
                        <HeaderBar />
                    </Grid>
                </Grid>
            )}
                <MyRoutes
                    setAuthToken={setAuthToken}
                    handleAnswerCreate={handleAnswerCreate}
                />
        </ThemeProvider>
    );
};

export default App;
